import './polyfills.js';

import React from 'react';
import { createRoot } from 'react-dom/client';
import AppRoutes from './App.jsx';
import './style.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<AppRoutes />);